/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', () => {
    
    document.body.addEventListener('click', (e) => {
      const button = e.target.closest('.quick-add__button.tbyb-button');
      if (!button) return;

      const observer = new MutationObserver(() => {
        const spinner = button.querySelector('.loading-spinner');
        if (spinner) {
          spinner.style.display = 'none';
          spinner.remove(); // optional: remove it entirely
        }
      });

      observer.observe(button, {
        attributes: true,
        childList: true,
        subtree: true
      });

      setTimeout(() => observer.disconnect(), 5000);
    });
  });

  // Delegated handler for all Try Before You Buy buttons
document.addEventListener('click', function(event) {
  // Find the closest element with the tbyb-button class (handles clicks on child elements)
  const btn = event.target.closest('.tbyb-button');
  if (!btn) return;

  // Prevent parent anchors / card clicks from navigating
  event.preventDefault();
  event.stopPropagation();

  // If the button is disabled, ignore
  if (btn.disabled || btn.getAttribute('aria-busy') === 'true' || btn.hasAttribute('disabled')) {
    return;
  }

  // Safely read data attributes (fallbacks)
  const productId = btn.dataset.productId || btn.getAttribute('data-product-id');
  let variantId = btn.dataset.variantId || btn.getAttribute('data-variant-id');

  // If variantId missing, try to find it on a containing product card element
  if (!variantId) {
    const card = btn.closest('[data-product-id], .product-card, .product-grid-item');
    if (card) {
      variantId = card.dataset.variantId || card.getAttribute('data-variant-id') || card.getAttribute('data-first-variant-id');
    }
  }

  // Basic validation
  if (!productId) {
    console.warn('TBYB: missing product id for button', btn);
    return;
  }

  // Optionally show spinner / set busy state
  btn.setAttribute('aria-busy', 'true');

  // ====== YOUR TBYB LOGIC HERE ======
  // Example: open a modal, call an API, add to cart, or trigger existing handler
  // Replace the following with the real Try-Before-You-Buy flow you use.
  (async function runTBYB() {
    try {
      console.log('TBYB triggered', { productId, variantId });
      // example: open modal with product + variant info
      // openTBYBModal(productId, variantId);
    } catch (err) {
      console.error('TBYB error', err);
    } finally {
      // clear busy state
      btn.setAttribute('aria-busy', 'false');
    }
  })();
});


  
})();

